import React from "react";

const HourlyBookingSummary = ({ hourlyPackages = [] }) => (
    <div className="hourly-booking-summary-container" style={{ padding: "0 10px" }}>
        <h4>Hourly Booking Summary</h4>

        <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", 
            gap: "16px",
            marginBottom: "20px"
        }}>
            {hourlyPackages.map((pkg, index) => {
                const subTotal = pkg.services.reduce((sum, s) => sum + s.price, 0);

                return (
                    <div key={index} style={{
                        backgroundColor: "#E6DCCF",
                        borderRadius: "12px",
                        border: "1px solid rgba(0,0,0,0.05)",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                    }}>
                        {/* Header Section */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ 
                                color: "#000000", 
                                fontSize: "12px", 
                                fontWeight: "800", 
                                textTransform: "uppercase",
                                border: "1px solid #000000",
                                padding: "2px 8px",
                                borderRadius: "4px"
                            }}>
                                {pkg.category || "Standard"}
                            </span>
                            <span style={{ fontSize: "14px", fontWeight: "700", color: "#000000" }}>
                                ⏱️ {pkg.hours}
                            </span>
                        </div>

                        {/* Service List */}
                        <div style={{ 
                            padding: "4px 0"
                        }}>
                            {pkg.services.map((s, i) => (
                                <div key={i} style={{ 
                                    display: "flex", 
                                    justifyContent: "space-between", 
                                    fontSize: "14px", 
                                    padding: "6px 0",
                                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                                    color: "#000000"
                                }}>
                                    <span style={{ fontWeight: "500" }}>{s.qty} × {s.name}</span>
                                    <span style={{ fontWeight: "700" }}>₹{s.price.toLocaleString()}</span>
                                </div>
                            ))}
                        </div>

                        {/* Footer / Total */}
                        <div style={{ 
                            marginTop: "auto", 
                            display: "flex", 
                            justifyContent: "space-between", 
                            alignItems: "center",
                            paddingTop: "12px",
                            borderTop: "2px solid rgba(0,0,0,0.1)"
                        }}>
                            <span style={{ fontSize: "14px", color: "#000000", fontWeight: "700" }}>Total:</span>
                            <span style={{ fontSize: "18px", fontWeight: "900", color: "#000000" }}>₹{subTotal.toLocaleString()}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
);

export default HourlyBookingSummary;
